<div class='subMenuContainer' [class.collapsed]="collapsed">
    <div class='title' *ngIf="!collapsed">
        <h2> {{subTitle}} </h2>
    </div>
    <!-- Creates SubMenus links from Object Array -->
    <div class="subMenuList">
        <nav *ngFor='let item of subMenuInfo'>
            <a class="subMenu" routerLinkActive="active" [routerLink]="item['subMenuLink']"
               [title]="collapsed ? item['subMenuTitle'] : null">
                <div class='subMenuIcon'><img [src]="item['subMenuIcon']" alt="" /></div>
                <div class='subMenuText' *ngIf="!collapsed">
                    <p class='subTitle'>{{ item['subMenuTitle'] }}</p>
                    <p class='subDesc'>{{ item['subMenuDesc'] }}</p>
                </div>
            </a>
        </nav>
    </div>
</div>